module.exports = __webpack_public_path__ + "static/creator-tokens-foreground-34567ab82a217bb0c672590792b7c97d.png";